type IsEmptyConfigs = {
  nullable?: boolean
  number?: {
    allowZero: boolean
  }
  array?: {
    allowEmpty: boolean
  }
}

const InitConfigs = {
    nullable: false,
    number: { allowZero: false },
    array: { allowEmpty: false },
  }
  

export function isEmpty(value: unknown, configs?: IsEmptyConfigs): boolean {
    const initConfigs = { ...InitConfigs, ...configs }
    if (value == null) {
      return !initConfigs.nullable
    }
    if (typeof value === 'boolean') return !value
    if (typeof value === 'number') {
      if (value === 0) {
        return !initConfigs.number.allowZero
      } else {
        return false
      }
    }
    if (typeof value === 'string') return value.trim().length === 0
    if (Array.isArray(value)) {
      if (value.length === 0) {
        return !initConfigs.array.allowEmpty
      } else {
        return false
      }
    }
    if (typeof value === 'object') return Object.keys(value).length === 0
    return false
  }


  export function findMissingRequiredKeys(
    obj: Record<string, unknown>,
    keys: string[],
    configs?: IsEmptyConfigs
  ): string[] {
    const missingOrEmptyKeys: string[] = []

    keys.forEach((key) => {
      if (
        !Object.prototype.hasOwnProperty.call(obj, key) ||
        isEmpty(obj[key], configs)
      ) {
        missingOrEmptyKeys.push(key)
      }
    })

    return missingOrEmptyKeys
  }